import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AppRouter } from './router'
import '@/index.css'
import '@fontsource/poppins/400.css'
import '@fontsource/poppins/600.css'
import './i18n'
import { ErrorBoundary } from './components/common/ErrorBoundary'
import { logger } from '@/utils/logger'

setTimeout(() => {
  logger.init()
}, 0)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 60_000, retry: 3 },
  },
})

import { LazyMotion, domAnimation } from 'framer-motion'
import { HelmetProvider } from 'react-helmet-async'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <ErrorBoundary>
          <LazyMotion features={domAnimation}>
            <AppRouter />
          </LazyMotion>
        </ErrorBoundary>
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>,
)
